export const categoriesAndProperties = {
  properties: "Ιδιότητες",
  addProperty: "Προσθήκη Ιδιότητας",
  addCategory: "Προσθήκη Κατηγορίας",
  addSubCategory: "Προσθήκη Υποκατηγορίας",
  addExtraCategory: "Προσθήκη Επιπλέον Κατηγορίας",
  category: "Κατηγορία",
  subCategory: "Υποκατηγορία",
  subCategories: "Υποκατηγορίες",
  extraCategory: "Επιπλέον Κατηγορία",
  extraCategories: "Επιπλέον Κατηγορίες",
  selectProperty: "Επιλογή Ιδιότητας",
  isNumerical: "Είναι Αριθμητική",
  value: "Αξία",
  uom: "Μονάδα Μέτρησης",
  selectCategory: "Επιλογή Κατηγορίας",
  categoriesJsonImport: "Εισαγωγή κατηγοριών από αρχείο JSON",
  categoriesJsonChooseFile: "Επιλογή αρχείου JSON",
  categoriesJsonNoFile: "Δεν έχει επιλεγεί αρχείο",
  categoriesJsonEmptyFile: "Επιλέξτε ένα αρχείο JSON για εισαγωγή.",
  categoriesJsonInvalid:
    "Δεν ήταν δυνατή η ανάγνωση ή η ανάλυση του αρχείου JSON.",
  categoriesJsonBadStructure:
    'Το JSON πρέπει να είναι πίνακας αντικειμένων με "name" και προαιρετικό "children", ή { "categories": [...] }.',
  categoriesImportDone: "Εισήχθησαν {{count}} κατηγορίες.",
  categoriesImportFailed: "Η εισαγωγή κατηγοριών απέτυχε.",
  categoriesDeleteAll: "Διαγραφή όλων των κατηγοριών",
  categoriesDeleteAllConfirm:
    "Θα διαγραφούν οριστικά όλες οι κατηγορίες, υποκατηγορίες και επιπλέον κατηγορίες. Η ενέργεια δεν μπορεί να αναιρεθεί.",
  categoriesDeleteAllDone: "Διαγράφηκαν {{count}} κατηγορίες.",
  categoriesDeleteAllEmpty: "Δεν υπάρχουν κατηγορίες για διαγραφή.",
  categoriesDeleteAllFailed: "Δεν ήταν δυνατή η διαγραφή όλων των κατηγοριών.",
  categoriesRateLimited:
    "Ο διακομιστής περιόρισε τα αιτήματα κατηγοριών. Περιμένετε λίγο και δοκιμάστε ξανά.",
  propertiesJsonImport: "Ανέβασμα σχήματος πρόσθετων ιδιοτήτων",
  propertiesJsonChooseFile: "Επιλογή αρχείου JSON",
  propertiesJsonNoFile: "Δεν έχει επιλεγεί αρχείο",
  propertiesJsonEmptyFile: "Επιλέξτε ένα αρχείο σχήματος JSON για ανέβασμα.",
  propertiesJsonInvalid:
    "Δεν ήταν δυνατή η ανάγνωση ή η ανάλυση του αρχείου JSON.",
  propertiesJsonBadStructure:
    'Το JSON πρέπει να είναι πίνακας αντικειμένων JSON ή ακριβώς { "additionalParameters": [ ... ] }. Κάθε αντικείμενο πρέπει να έχει μόνο τα κλειδιά: key, label, dataType, required, defaultValue, validationRule, class, group. Κάθε τιμή επιτρέπεται να είναι null. Το class πρέπει να είναι null ή μη κενή συμβολοσειρά (καθολικό όταν είναι null). Το group είναι μόνο για το frontend: null τοποθετεί το πεδίο στην καρτέλα Ιδιότητες· μη κενή συμβολοσειρά δημιουργεί ξεχωριστή καρτέλα με το όνομα της ομάδας.',
  propertiesJsonStrictErrorRoot:
    'Το JSON πρέπει να είναι πίνακας ή αντικείμενο με μία ιδιότητα { "additionalParameters": [...] }.',
  propertiesJsonStrictErrorRowNotObject:
    "Η γραμμή {{index}} πρέπει να είναι αντικείμενο JSON.",
  propertiesJsonStrictErrorUnknownKey:
    'Η γραμμή {{index}} περιέχει άγνωστη ιδιότητα "{{prop}}". Επιτρεπόμενα κλειδιά: key, label, dataType, required, defaultValue, validationRule, class, group.',
  propertiesJsonStrictErrorMissingKey:
    'Η γραμμή {{index}} δεν περιέχει την απαιτούμενη ιδιότητα "{{prop}}".',
  propertiesJsonStrictErrorKey:
    "Η γραμμή {{index}}: το key πρέπει να είναι συμβολοσειρά ή null.",
  propertiesJsonStrictErrorLabel:
    "Η γραμμή {{index}}: το label πρέπει να είναι συμβολοσειρά ή null.",
  propertiesJsonStrictErrorDataType:
    "Η γραμμή {{index}}: το dataType πρέπει να είναι συμβολοσειρά ή null.",
  propertiesJsonStrictErrorRequired:
    "Η γραμμή {{index}}: το required πρέπει να είναι boolean ή null.",
  propertiesJsonStrictErrorDefaultValue:
    "Η γραμμή {{index}}: το defaultValue πρέπει να είναι συμβολοσειρά, αριθμός, boolean ή null.",
  propertiesJsonStrictErrorValidationRule:
    "Η γραμμή {{index}}: το validationRule πρέπει να είναι συμβολοσειρά ή null.",
  propertiesJsonStrictErrorRegex:
    "Η γραμμή {{index}}: το validationRule δεν είναι έγκυρη κανονική έκφραση.",
  propertiesJsonStrictErrorClass:
    "Η γραμμή {{index}}: το class πρέπει να είναι null ή μη κενή συμβολοσειρά.",
  propertiesJsonStrictErrorGroup:
    "Η γραμμή {{index}}: το group πρέπει να είναι null ή μη κενή συμβολοσειρά.",
  propertiesTableClass: "class",
  propertiesTableGroup: "group",
  propertiesImportDone: "Εισήχθησαν {{count}} ιδιότητες.",
  propertiesImportDonePartial:
    "Εισήχθησαν {{created}} ιδιότητες· {{skipped}} γραμμές παραλείφθηκαν (χωρίς έγκυρο μη κενό key).",
  propertiesImportNoneCreated:
    "Δεν εισήχθη καμία ιδιότητα. Κάθε γραμμή καταλόγου χρειάζεται μη κενό key ως συμβολοσειρά.",
  propertiesSchemaUploadDone:
    "Το σχήμα πρόσθετων ιδιοτήτων αποθηκεύτηκε ως {{fileName}}.",
  propertiesSchemaUploadFailed:
    "Το ανέβασμα του σχήματος πρόσθετων ιδιοτήτων απέτυχε.",
  propertiesSchemaLoadError:
    "Δεν ήταν δυνατή η φόρτωση του αποθηκευμένου σχήματος πρόσθετων ιδιοτήτων. Δοκιμάστε ξανά ή επικοινωνήστε με την υποστήριξη.",
  propertiesSavedSchemaRibbonFallback: "Τρέχον αποθηκευμένο σχήμα",
  propertiesSavedSchemaActiveFileHint: "Σχήμα αποθηκευμένο στον διακομιστή",
  propertiesImportFailed: "Η εισαγωγή ιδιοτήτων απέτυχε.",
  propertiesImportPreviewHeading: "Προεπισκόπηση εισαγωγής",
  propertiesImportPreviewSub:
    "Ελέγξτε τις παραμέτρους από το επιλεγμένο αρχείο. Χρησιμοποιήστε Υποβολή παρακάτω για αποθήκευση ως το τρέχον σχήμα πρόσθετων ιδιοτήτων.",
  propertiesSavedHeading: "Αποθηκευμένα στον κατάλογο",
  propertiesSubmittedSchemaHeading: "Υποβληθέν σχήμα",
  propertiesSubmittedSchemaSub:
    "Αυτό είναι το σχήμα που είναι αποθηκευμένο στον διακομιστή για την αγορά. Για να το αντικαταστήσετε, ανεβάστε νέο αρχείο JSON.",
  propertiesEmptyCatalog:
    "Δεν έχουν αποθηκευτεί ακόμα χαρακτηριστικά στον κατάλογο.",
  propertiesFieldKey: "Κλειδί",
  propertiesBadgeRequired: "Υποχρεωτικό",
  propertiesBadgeOptional: "Προαιρετικό",
  propertiesNoValidationRule: "Χωρίς μοτίβο",
  propertiesFieldDefault: "Προεπιλογή",
  propertiesFieldValidation: "Μοτίβο επικύρωσης",
  propertiesTableIndex: "#",
  propertiesTableFieldId: "Αναγνωριστικό πεδίου",
  propertiesTableDisplayName: "Εμφανιζόμενο όνομα",
  propertiesTableKeyHeader: "key",
  propertiesTableLabelHeader: "label",
  propertiesTableDataType: "dataType",
  propertiesTableRequired: "required",
  propertiesTableDefaultValue: "defaultValue",
  propertiesTableValidationPattern: "Μοτίβο επικύρωσης",
  propertiesTableValidationRule: "validationRule",
  propertiesTableOtherFields: "Λοιπά πεδία",
  propertiesTableYes: "Ναι",
  propertiesTableNo: "Όχι",
  propertiesTableNotApplicable: "—",
  propertiesTableNotSet: "Δεν ορίστηκε",
  propertiesTableNone: "Καμία",
};
